
class RemoteBotInstall {
	static async getSubscribedBots() {
	  return [];
	}
  
	static getBotManifestFromId(botID, catalog) {
	  const subscribedBotManifest = (catalog.bots || []).find(
		(manifest) => manifest.botId === botID
	  );
	  return subscribedBotManifest;
	}
  
	static async isSatellite() {
	  return false;
	}
  
	static async installBot(botManifest) {
	  return true;
	}
  
	static async synchronizeBots() {
	  return;
	}
  };
  
  export default RemoteBotInstall;
  